module.exports = __webpack_public_path__ + "static/img/major_pictgrid1_800x664.cbd8219.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid1_800x664.jpg
// module id = 7V7H
// module chunks = 0